import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import {
  ScrollToTopOnMount,
  ExtendedBox,
  AnimationContainer,
  ExtendedFlex,
  Loader,
  LoaderMessage,
} from '../../coreui';

import PageHeading from '../components/PageHeading';
import BrowseNav from '../components/BrowseNav';
import Blurb from '../components/Blurb';
import InvestmentCards from '../components/InvestmentCards';
import PrivatePlacementMessage from '../components/PrivatePlacementMessage';

import actions from './actions';
import browseActions from '../browsePage/actions';
import RedirectToLoginOnLoggedOut from '../../components/RedirectToLoginOnLoggedOut';

class ActiveInvestments extends React.Component {
  constructor(props) {
    super(props);
    this.updateSelectedFilterValue = this.updateSelectedFilterValue.bind(this);
    this.hydrateInvestmentCard = this.hydrateInvestmentCard.bind(this);
    this.watchInvestmentFlag = this.watchInvestmentFlag.bind(this);
    this.state = {
      ...(this.hydrateInvestmentCard(props.investments, false)),
    };
  }

  componentDidMount() {
    if (!this.props.redirecting) {
      this.props.getBrowsePageDataRequested();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.investments !== this.props.investments) {
      this.setState({
        ...(this.hydrateInvestmentCard(nextProps.investments, true)),
      });
    }
  }

  hydrateInvestmentCard(investments, allowNoAnimate) {
    return {
      investments: investments.reduce((items, item) => {
        return [
          ...items,
          {
            ...(
              item.status === 'status-20-coming-soon' ? {
                ...item,
                noAnimate: item.noAnimate && allowNoAnimate,
                watchlist: {
                  text: item.watchlist.flagged ?
                    item.watchlist.unflag : item.watchlist.flag,
                  handleClick: () => {
                    return this.watchInvestmentFlag(item);
                  },
                  loading: item.watchlist.loading,
                },
              } : item
            ),
          },
        ];
      }, []),
    };
  }

  updateSelectedFilterValue(value) {
    this.props.updateSelectedFilterValue(value);
  }

  watchInvestmentFlag(investment) {
    this.props.watchInvestmentFlag(investment);
  }

  render() {
    const {
      redirecting,
      loaded,
      retryCount,
      selectedIoType,
      accreditationRoleStatus,
      gtkySubmittedApproved,
      gtkyStatus,
      browseNavAnimationSettings,
      updateBrowseNavAnimationSettings,
      isSelfAccredCooledOff,
      gtkyAccessPendingIO,
    } = this.props;

    const investments = gtkyStatus === 'submitted' && !isSelfAccredCooledOff ? [
      ...[gtkyAccessPendingIO],
      ...this.state.investments,
    ] : this.state.investments;

    return (
      <ExtendedFlex
        flexDirection="column"
        align="center"
        bg="gray.0"
        w={[1]}
        pb={40}
        {
        ...((!loaded || redirecting) ? {
          zIndex: 2,
          position: 'relative',
          minHeight: '90vh',
        } : {})
        }
      >
        <ScrollToTopOnMount />
        <RedirectToLoginOnLoggedOut />
        <ExtendedBox
          w={1}
          maxWidth={1600}
        >
          <AnimationContainer
            name="fadeInUp"
            duration="1s"
            fillMode="backwards"
            delay="0s"
          >
            <PageHeading
              title="Open Investment Opportunities"
              alignment="center"
            />
          </AnimationContainer>
          {
            (!loaded || redirecting) &&
            <Loader>
              {
                retryCount > 0 &&
                <LoaderMessage />
              }
            </Loader>
          }
          {
            loaded && accreditationRoleStatus === 'Accredited' &&
            <AnimationContainer
              name="fadeIn"
              duration={browseNavAnimationSettings.duration}
              fillMode="backwards"
              delay={browseNavAnimationSettings.delay}
              onEnd={updateBrowseNavAnimationSettings}
            >
              <BrowseNav />
            </AnimationContainer>
          }
          {
            loaded && !redirecting &&
            <AnimationContainer
              name="fadeIn"
              duration="1s"
              fillMode="backwards"
              delay="0.50s"
            >
              <Blurb
                blurb={`
                  Each investment opportunity is carefully analyzed by the experienced
                  RealtyMogul credit team, ensuring only vetted properties are offered
                  to our members.
                `}
              />
            </AnimationContainer>
          }
          {
            loaded && !redirecting &&
            <InvestmentCards
              investments={investments}
              accreditationRoleStatus={accreditationRoleStatus}
              gtkySubmittedApproved={gtkySubmittedApproved}
              emptyText="There are currently no investment opportunities of this type."
              selectedIoType={selectedIoType}
            />
          }
        </ExtendedBox>
        {
          loaded && !redirecting && gtkyStatus !== 'submitted' &&
          <PrivatePlacementMessage
            accreditationRoleStatus={accreditationRoleStatus}
            gtkyStatus={gtkyStatus}
            isSelfAccredCooledOff={isSelfAccredCooledOff}
          />
        }
      </ExtendedFlex>
    );
  }
}

const mapStateToProps = state => ({
  loaded: state.activeInvestments.loaded,
  retryCount: state.activeInvestments.retryCount,
  ioTypes: state.activeInvestments.ioTypes,
  selectedIoType: state.activeInvestments.selectedIoType,
  investments: state.activeInvestments.investments,
  gtkyAccessPendingIO: state.activeInvestments.gtkyAccessPendingIO,
  investmentsCount: state.activeInvestments.investmentsCount,
  accreditationRoleStatus: state.activeInvestments.accreditationRoleStatus,
  gtkySubmittedApproved: state.activeInvestments.gtkySubmittedApproved,
  gtkyStatus: state.activeInvestments.gtkyStatus,
  isSelfAccredCooledOff: state.activeInvestments.isSelfAccredCooledOff,
});

const mapDispatchToProps = dispatch => ({
  getBrowsePageDataRequested: () => {
    dispatch(browseActions.getBrowseOpenDataRequested());
  },
  updateSelectedFilterValue: (value) => {
    dispatch(actions.updateSelectedCurrentInvestmentFilterValue(value));
  },
  watchInvestmentFlag: (investment) => {
    dispatch(actions.watchInvestmentFlagRequested(investment));
  },
});

ActiveInvestments.propTypes = {
  redirecting: PropTypes.bool,
  loaded: PropTypes.bool,
  retryCount: PropTypes.number,
  ioTypes: PropTypes.arrayOf(PropTypes.object),
  selectedIoType: PropTypes.string,
  updateSelectedFilterValue: PropTypes.func,
  investments: PropTypes.array,
  accreditationRoleStatus: PropTypes.string,
  gtkySubmittedApproved: PropTypes.bool,
  showWelcomeMessage: PropTypes.bool,
  gtkyStatus: PropTypes.string,
  updateBrowseNavAnimationSettings: PropTypes.func,
  browseNavAnimationSettings: PropTypes.object,
  watchInvestmentFlag: PropTypes.func,
  getBrowsePageDataRequested: PropTypes.func,
  isSelfAccredCooledOff: PropTypes.bool,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActiveInvestments));
